<template>
  <CardComponent :image="image" class="rcs-card">
    <template v-if="isPreview">
      <h4 class="card-title">{{ title }}</h4>
      <p class="card-text">{{ description }}</p>
      <span v-for="(button, n) in buttons" :key="n">
        <SeparatorComponent v-if="n > 0" />
        <ButtonComponent v-if="button.type === 'dial'" variant="tertiary">
          <div class="material-symbols-outlined">call</div>
          Entre em contato
        </ButtonComponent>
        <ButtonComponent v-else-if="button.type === 'reply'" variant="tertiary" is-block>
          {{ button.text }}
        </ButtonComponent>
        <ButtonComponent v-else-if="button.type === 'url'" variant="tertiary" is-block>
          <div class="material-symbols-outlined">public</div>
          {{ button.text }}
        </ButtonComponent>
        <ButtonComponent v-else-if="button.type === 'location'" variant="tertiary" is-block>
          <div class="material-symbols-outlined">location_on</div>
          {{ button.text }}
        </ButtonComponent>
        <ButtonComponent v-else-if="button.type === 'event'" variant="tertiary" is-block>
          <div class="material-symbols-outlined">calendar_month</div>
          {{ button.title }}
        </ButtonComponent>
      </span>
    </template>
    <template v-else>
      <i v-if="!isPreview" @click="$refs.uploadMenu.show()" class="fas fa-edit card-edit-btn absolute c-pointer"></i>
      <div class="to-left text-right">
        <img style="width: 20px; height: 20px; margin-bottom: 10px;" src="assets/img/icons/info-tolltip.svg" class="circle-info" v-tooltip.top="'Adicione variáveis usando {nome_variavel} no seu template. Ao enviar via API, substitua pelos valores reais através do parâmetro variables. Exemplo: {nome}, {email}, {codigo}'"/>
      </div>
      <InputComponent :placeholder="$tc('app.title')" v-model="title" />
      <TextAreaComponent :placeholder="$tc('app.description')" v-model="description" />
      <span v-for="(button, n) in buttons" :key="n">
        <SeparatorComponent v-if="n > 0" />
        <InputComponent v-if="button.type === 'reply'" :placeholder="$tc('app.text')" v-model="button.text">
          <template #append>
            <ButtonComponent @click="removeButton(n)">
              <span class="material-symbols-outlined">delete</span>
            </ButtonComponent>
          </template>
        </InputComponent>
        <TelInputComponent v-else-if="button.type === 'dial'" :placeholder="$tc('app.text')" v-model="button.phoneNumber">
          <template #append>
            <ButtonComponent @click="removeButton(n)">
              <span class="material-symbols-outlined">delete</span>
            </ButtonComponent>
          </template>
        </TelInputComponent>
        <div v-if="button.type === 'url'">
          <InputComponent :placeholder="$tc('app.text')" v-model="button.text">
            <template #prepend>
              <span class="input-group-text">
                <span class="material-symbols-outlined"> language </span>
              </span>
            </template>
            <template #append>
              <ButtonComponent @click="removeButton(n)">
                <span class="material-symbols-outlined">delete</span>
              </ButtonComponent>
            </template>
          </InputComponent>
          <InputComponent placeholder="URL" v-model="button.url">
            <template #prepend>
              <span class="input-group-text">
                <span class="material-symbols-outlined"> language </span>
              </span>
            </template>
            <template #append>
              <ButtonComponent @click="removeButton(n)">
                <span class="material-symbols-outlined">delete</span>
              </ButtonComponent>
            </template>
          </InputComponent>
        </div>
        <template v-if="button.type === 'location'">
          <InputComponent :placeholder="$tc('app.text')" v-model="button.text">
            <template #prepend>
              <span class="input-group-text">
                <span class="material-symbols-outlined"> location_on </span>
              </span>
            </template>
            <template #append>
              <ButtonComponent @click="removeButton(n)">
                <span class="material-symbols-outlined">delete</span>
              </ButtonComponent>
            </template>
          </InputComponent>
          <InputComponent :placeholder="$tc('app.location')" v-model="button.address" required>
            <template #prepend>
              <span class="input-group-text">
                <span class="material-symbols-outlined"> location_on </span>
              </span>
            </template>
            <iframe
              v-if="button.address"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
              id="gmap_canvas"
              :src="`https://maps.google.com/maps?amp;hl=en&amp;q=${button.address}&amp;t=&amp;z=19&amp;ie=UTF8&amp;iwloc=B&amp;output=embed`"
              width="300"
              height="400"
              frameborder="0"
            >
            </iframe>
            <template #append>
              <ButtonComponent @click="removeButton(n)">
                <span class="material-symbols-outlined">delete</span>
              </ButtonComponent>
            </template>
          </InputComponent>
        </template>
        <div v-if="button.type === 'event'">
          <InputComponent :placeholder="$tc('app.text')" v-model="button.text">
            <template #prepend>
              <span class="input-group-text">
                <span class="material-symbols-outlined"> calendar_month </span>
              </span>
            </template>
            <template #append>
              <ButtonComponent @click="removeButton(n)">
                <span class="material-symbols-outlined">delete</span>
              </ButtonComponent>
            </template>
          </InputComponent>
          <InputComponent :placeholder="$tc('app.name')" v-model="button.title">
            <template #prepend>
              <span class="input-group-text">
                <span class="material-symbols-outlined"> calendar_month </span>
              </span>
            </template>
            <template #append>
              <ButtonComponent @click="removeButton(n)">
                <span class="material-symbols-outlined">delete</span>
              </ButtonComponent>
            </template>
          </InputComponent>
          <DateComponent v-model="button.date">
            <template #prepend>
              <span class="input-group-text">
                <span class="material-symbols-outlined"> calendar_month </span>
              </span>
            </template>
          </DateComponent>
        </div>
      </span>
      <div v-if="buttons.length < 4" class="row">
        <div class="col-12 btn-actions">
          <button type="button" class="btn-add-action"><span class="material-symbols-outlined info-icons info-var-tip">flash_on</span> Adicionar ação</button>
          <button type="button" class="btn-add-action-hover">
            <span class="material-symbols-outlined" @click="addButton('dial')">phone</span>
            <span class="material-symbols-outlined" @click="addButton('reply')">text_fields</span>
            <span class="material-symbols-outlined" @click="addButton('url')">public</span>
            <span class="material-symbols-outlined" @click="addButton('location')">location_on</span>
            <span class="material-symbols-outlined" @click="addButton('event')">calendar_month</span>
          </button>
        </div>
      </div>
      <UploadComponent
        :preview="true"
        ref="uploadMenu"
        accept="image/jpeg, image/jpg, image/gif, image/png, video/h263, video/m4v, video/mp4, video/mpeg, video/mpeg4, video/webm"
        :maxFileSize="100"
        @uploaded="updateMedia"
      />
    </template>
  </CardComponent>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import TextAreaComponent from '@/components/form/TextAreaComponent.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import TelInputComponent from '@/components/form/TelInputComponent.vue';
import UploadComponent from '@/components/ui/UploadComponent/Index.vue';
import SeparatorComponent from '../ui/SeparatorComponent.vue';
import DateComponent from '../form/DateComponent.vue';

export default {
  name: 'RcsCard',
  components: {
    CardComponent,
    InputComponent,
    TextAreaComponent,
    ButtonComponent,
    TelInputComponent,
    SeparatorComponent,
    DateComponent,
    UploadComponent,
  },
  props: {
    isPreview: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({
        image: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
        title: '',
        description: '',
        buttons: [],
      }),
    },
  },
  data() {
    return {
      image: this.value.image || 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
      title: this.value.title || '',
      description: this.value.description || '',
      buttons: this.value.buttons || [],
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.image = newVal.image;
          this.title = newVal.title;
          this.description = newVal.description;
          this.buttons = newVal.buttons || [];
        }
      },
      deep: true,
    },
    title(newVal) {
      this.updateValue();
    },
    description(newVal) {
      this.updateValue();
    },
    image(newVal) {
      this.updateValue();
    },
    buttons: {
      handler(newVal) {
        this.updateValue();
      },
      deep: true,
    },
  },
  methods: {
    updateValue() {
      this.$emit('input', {
        title: this.title,
        description: this.description,
        buttons: this.buttons,
        image: this.image,
      });
    },
    updateMedia(media) {
      this.image = media.data.path;
    },
    addButton(type) {
      if (this.buttons.length >= 4) {
        this.$toast.show({
          title: this.$t('app.error'),
          content: this.$t('rcs.max_buttons'),
          type: 'success',
        });
        return;
      }
      if (type === 'reply') {
        this.buttons.push({
          type,
          text: '',
        });
      } else if (type === 'dial') {
        this.buttons.push({
          type,
          phoneNumber: '',
        });
      } else if (type === 'url') {
        this.buttons.push({
          type,
          url: '',
          text: '',
          description: '',
        });
      } else if (type === 'location') {
        this.buttons.push({
          type,
          text: '',
          address: '',
        });
      } else if (type === 'event') {
        this.buttons.push({
          type,
          text: '',
          title: '',
          date: [`${new Date().toISOString().split('T')[0]} 00:00`, `${new Date().toISOString().split('T')[0]} 23:59`],
          description: '',
        });
      }
    },
    removeButton(index) {
      this.buttons.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.separator {
  margin-top: -15px;
}
.rcs-card {
  border-radius: 0.75rem;
  margin-left: 0px;
  margin-right: 5px;
  ::v-deep .card-img-top {
    border-top-left-radius: calc(0.75rem - 1px);
    border-top-right-radius: calc(0.75rem - 1px);
  }
}
.carousel {
  .rcs-card {
    flex: 0 0 210px;
  }
}
.btn-add-action {
  width: 100%;
  background: #fff;
  border: dashed 2px #6f6f6f;
  border-radius: 8px;
  margin-top: 10px;
  padding: 5px;
  align-content: center;
  color: #101828;
  font-size: 13px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.btn-add-action span {
  font-size: 16px;
  color: #101828;
}
.btn-add-action-hover {
  width: 100%;
  background: #fff;
  border: dashed 2px #6f6f6f;
  border-radius: 8px;
  margin-top: 10px;
  padding: 5px;
  align-content: center;
  color: #101828;
  font-size: 13px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  display: none;
}
.btn-add-action-hover span {
  flex: 1;
  font-size: 19px;
}
.btn-add-action-hover span:nth-child(1) {
  color: #752de6 !important;
}
.btn-add-action-hover span:nth-child(3) {
  color: #0099ff !important;
}
.btn-add-action-hover span:nth-child(4) {
  color: #870e1e !important;
}
.btn-add-action-hover span:nth-child(5) {
  color: #16870e !important;
}
.btn-actions:hover .btn-add-action-hover {
  display: flex;
}
.btn-actions:hover .btn-add-action {
  display: none;
}
.card-edit-btn {
  margin: 10px;
  color: #fff;
  cursor: pointer;
  left: 0;
  top: 0;
}
.card-edit-btn i {
  color: #fff !important;
}
.card-edit-btn:hover {
  color: rgb(230, 230, 230);
}
</style>
